let groups = {}

const addGroup = (id, mess) => {
  groups[id] = mess
}

const workerGroup = {
  addGroup,
  groups
}

module.exports = workerGroup